import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import ProfileDesktop from '../components/faraaz/ProfileDesktop'
import ProfileMobile from '../components/faraaz/ProfileMobile'
import AjmalMusthafaImg from '../assets/images/Ajmal.png'

const AjmalMusthafa = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
                <meta charSet="utf-8" />
                <title>Ajmal Musthafa - 800 Homes</title>
            </Helmet>

            <section id="website-responsive" className="d-none d-md-block">
                <ProfileDesktop
                    Image={AjmalMusthafaImg}
                    Title="Ajmal Musthafa"
                    Designation="Marketing Manager"
                    PhoneNumberLink="+971545790914"
                    PhoneNumber="+971 54 579 0914"
                    WhatsappLink="971545790914"
                    Whatsapp="+971 54 579 0914"
                    Email="marketing@800homes.ae"
                />
            </section>

            <section id="website-responsive" className="d-block d-md-none">
                <ProfileMobile
                    Image={AjmalMusthafaImg}
                    Title="Ajmal Musthafa"
                    Designation="Marketing Manager"
                    PhoneNumberLink="+971545790914"
                    PhoneNumber="+971 54 579 0914"
                    WhatsappLink="971545790914"
                    Whatsapp="+971 54 579 0914"
                    Email="marketing@800homes.ae"
                />
            </section>
        </>
    )
}

export default AjmalMusthafa
